<template>
	<el-row class="container">
		<el-col
			:span="24"
			class="header"
		>
			<el-col
				class="logo"
				:class="collapsed ? 'logo-collapse-width' : 'logo-width'"
			>
				<div class="logoFlex">
					<img
						v-if="!collapsed"
						@click="goHome('/homePage')"
						src="../images/IndLogo.png"
						style="width:50px;height:46px;"
					/>
					<img
						v-else
						src="../images/IndLogo.png"
						style="width:49px;height:43px;"
						@click="goHome('/homePage')"
					/>
					<div
						v-if="!collapsed"
						class="collImg"
					>{{ platName ? platName : '运营平台' }}</div>
				</div>
				<i></i>
			</el-col>
			<!-- <div class="fanhuis">返回</div> -->
			<div
				class="flex_righs"
				style="flex:1;"
			>
				<div
					v-if="$route.query.idChilds"
					class="title title_updata"
					style=""
				>编辑子系统</div>
				<div
					v-else
					class="title title_name"
				>{{ $route.name }}</div>
				<div
					v-if="goBack2 == 'true'"
					class="goOrder"
				>
					<el-button @click="goOrder">返回上一页</el-button>
				</div>
				<el-col
					:span="2"
					class="userinfo shipeis"
				>
					<el-dropdown trigger="click">
						<span class="el-dropdown-link userinfo-inner">
							{{ sysUserName }}
							<span class="el-icon-caret-bottom"></span>
						</span>
						<el-dropdown-menu
							slot="dropdown"
							style="top:40px;"
						>
							<el-dropdown-item
								v-if="setButton"
								@click.native="goSet(1, plind)"
							>设置</el-dropdown-item>
							<el-dropdown-item v-else></el-dropdown-item>
							<el-dropdown-item
								divided
								@click.native="logout"
							>退出登录</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</el-col>
				<!-- 切换子系统 -->
				<el-dropdown
					trigger="click"
					class="tabchild"
					style="padding:0px 20px;float:right;cursor: pointer;"
					v-if="paltXt.length > 0"
				>
					<span class="el-dropdown-link userinfo-inner2">
						{{ platName ? platName : '请选择子系统' }}
						<span class="el-icon-caret-bottom"></span>
					</span>
					<el-dropdown-menu
						slot="dropdown"
						style="top:40px;"
					>
						<el-dropdown-item
							v-for="(item, index) in paltXt"
							:key="index"
							@click.native="childernXt(item.adminUrl, item.platId, item.platName)"
						>
							{{ item.platName }}
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>

				<div
					v-if="menuList.length > 0"
					class="yuyings"
					@click="goHome2('/homePage', 0)"
				>运营平台</div>
				<div v-else></div>
			</div>
		</el-col>
		<div
			class
			v-if="home"
		>
			<el-col
				:span="24"
				class="main"
			>
				<aside :class="collapsed ? 'menu-collapsed' : 'menu-expanded'">
					<el-menu
						:default-active="$route.path"
						id="lastclass"
						text-color="#FFFFFF"
						background-color="#46B4FF"
						class="el-menu-vertical-demo"
						@open="handleOpen"
						@close="handleClose"
						:collapse="collapsed"
						collapse-transition
						:unique-opened="true"
					>
						<!-- 子系统切换运营平台 -->
						<template v-if="childIndex">
							<template v-for="(item, index) in routes">
								<el-submenu
									v-if="!item.redirect && item.children && item.children.length"
									:index="index + ''"
									:key="index"
								>
									<template slot="title">
										<span v-if="item.icon != '' && item.icon && item.icon != 'undefined'">
											<div class="icons"><img :src="img + item.icon" /></div>
										</span>
										<span>{{ item.name }}</span>
									</template>
									<el-menu-item-group>
										<template v-for="items in item.children">
											<el-menu-item
												v-if="typeof items.hidden !== 'boolean'"
												:index="items.path"
												:key="items.path"
												@click="tourles(items.path)"
											>
												<span v-if="items.icon != '' && items.icon && items.icon != 'undefined'">
													<div class="icons"><img :src="img + items.icon" /></div>
												</span>
												<span>{{ items.name }}</span>
											</el-menu-item>
										</template>
									</el-menu-item-group>
								</el-submenu>
							</template>
						</template>
						<!-- 运营平台菜单 -->
						<template v-else-if="cookie < 2 && !$route.path.includes('setings')">
							<template v-for="(item, index) in routes">
								<el-submenu
									v-if="!item.redirect && item.children && item.children.length"
									:index="index + ''"
									:key="index"
								>
									<template slot="title">
										<span v-if="item.icon != '' && item.icon && item.icon != 'undefined'">
											<div class="icons"><img :src="img + item.icon" /></div>
										</span>
										<span>{{ item.name }}</span>
									</template>
									<el-menu-item-group>
										<template v-for="items in item.children">
											<el-menu-item
												v-if="typeof items.hidden !== 'boolean'"
												:index="items.path"
												:key="items.path"
												@click="tourles(items.path)"
											>
												<span v-if="items.icon != '' && items.icon && items.icon != 'undefined'">
													<div class="icons"><img :src="img + items.icon" /></div>
												</span>
												<span>{{ items.name }}</span>
											</el-menu-item>
										</template>
									</el-menu-item-group>
								</el-submenu>
							</template>
						</template>
						<!-- 子模块成立不是设置就是子模块 -->
						<template v-else-if="cookie >= 2 && !$route.path.includes('setings') && !childIndex">
							<el-submenu
								v-for="item in fromRouterData[0].childMenu"
								:index="item.funcName"
								:key="item.funcName"
								unique-opened
							>
								<template slot="title">
									<span v-if="item.icon != '' && item.icon && item.icon != 'undefined'">
										<div class="icons"><img :src="img + item.icon" /></div>
									</span>
									<span>{{ item.funcName }}</span>
								</template>
								<el-menu-item
									v-for="(items, index1) in item.childMenu"
									:index="items.funcName"
									:key="index1 + ''"
									@click="tourles2(items.funcUrl, items.funcName, items.funcName)"
								>
									<span v-if="items.icon != '' && items.icon && items.icon != 'undefined'">
										<div class="icons"><img :src="img + items.icon" /></div>
									</span>
									<span>{{ items.funcName }}</span>
									<!-- <el-menu-item v-for="itemB in items.childMenu" :index="itemB.funcUrl" :key="itemB.funcUrl" @click="tourles2(itemB.funcUrl,items.funcName)">
                              <span v-if='itemB.icon != "" && itemB.icon && itemB.icon != "undefined"'>
                                  <div class='icons' >
                                    <img :src="img+itemB.icon" >
                                  </div>
                              </span>
                              <span >{{itemB.funcName}}</span>
                          </el-menu-item> -->
								</el-menu-item>
							</el-submenu>
						</template>
						<!-- 设置页面 -->
						<template v-else-if="$route.path.includes('setings')">
							<el-submenu
								v-for="(item, index) in routset"
								v-if="!item.redirect && item.children && item.children.length"
								:index="index + ''"
								:key="index"
							>
								<template slot="title">
									<span v-if="item.icon != '' && item.icon && item.icon != 'undefined'">
										<div class="icons"><img :src="img + item.icon" /></div>
									</span>
									<span>{{ item.name }}</span>
								</template>
								<el-menu-item
									v-for="items in item.children"
									:index="items.path"
									:key="items.path"
									@click="tourles(items.path)"
								>
									<span v-if="items.icon != '' && items.icon && items.icon != 'undefined'">
										<div class="icons"><img :src="img + item.icon" /></div>
									</span>
									<span>{{ items.name }}</span>
								</el-menu-item>
							</el-submenu>
						</template>
					</el-menu>
					<div
						:class="!collapsed ? 'zhedeisi' : 'zhedeisi2'"
						@click.prevent="collapsed = !collapsed"
					>
						<img
							v-if="collapsed"
							src="../images/zhankai.png"
							alt=""
							srcset=""
						/>
						<img
							v-else
							src="../images/shouqi.png"
							alt=""
							srcset=""
						/>
						<span v-if="collapsed">展开</span>
						<span v-else>收起</span>
					</div>
				</aside>
				<section
					class="content-container"
					id="content-container"
				>
					<div class="grid-content bg-purple-light">
						<el-col
							:span="24"
							class="content-wrapper"
						>
							<transition
								name="fade"
								mode="out-in"
							>
								<div v-if="plind && !$route.path.includes('setings') && !childIndex">
									<div v-if="clickStus2">
										<div v-if="editableTabs.length <= 0">
											<iframe
												v-if="separe == 1"
												ref="mapFrame"
												:id="!collapsed ? 'ifrm1' : 'ifrm1s'"
												:src="admiUrl + '/#'"
												scrolling="auto"
												frameborder="0"
											></iframe>
											<iframe
												v-if="separe == 2"
												ref="mapFrame"
												:id="!collapsed ? 'ifrm1' : 'ifrm1s'"
												:src="clickStus ? admiUrl + ifromUrl : admiUrl + '/pages/index.html'"
												scrolling="auto"
												frameborder="0"
											></iframe>
											<iframe
												v-if="separe == 3"
												ref="mapFrame"
												:id="!collapsed ? 'ifrm1' : 'ifrm1s'"
												:src="admiUrl + '#'"
												scrolling="auto"
												frameborder="0"
											></iframe>
										</div>
										<el-tabs
											style="position:absolute;width:100%;height:100%;"
											v-else
											v-model="editableTabsValue"
											type="card"
											closable
											@tab-remove="removeTab"
										>
											<el-tab-pane
												v-for="item in editableTabs"
												:key="item.name"
												:label="item.title"
												:name="item.name"
											>
												<iframe
													v-if="separe == 1"
													ref="mapFrame"
													:id="!collapsed ? 'ifrm2' : 'ifrm2s'"
													:src="clickStus ? admiUrl + '/#' + item.ifromUrl : admiUrl + '/#' + item.ifromUrl"
													scrolling="auto"
													frameborder="0"
												></iframe>
												<iframe
													v-if="separe == 2"
													ref="mapFrame"
													:id="!collapsed ? 'ifrm2' : 'ifrm2s'"
													:src="clickStus ? admiUrl + item.ifromUrl : admiUrl + item.ifromUrl"
													scrolling="auto"
													frameborder="0"
												></iframe>
												<iframe
													v-if="separe == 3"
													ref="mapFrame"
													:id="!collapsed ? 'ifrm2' : 'ifrm2s'"
													:src="clickStus ? admiUrl + '#' + item.ifromUrl : admiUrl + '#' + item.ifromUrl"
													scrolling="auto"
													frameborder="0"
												></iframe>
											</el-tab-pane>
										</el-tabs>
									</div>
								</div>
								<!-- 运营平台 -->
								<div v-else-if="!$route.path.includes('setings') || !plind">
									<router-view></router-view>
								</div>
								<!-- 设置页面 -->
								<div v-else-if="$route.path.includes('setings') && childIndex">
									<router-view></router-view>
								</div>
								<!-- 子平台直接进入运营平台 -->
								<div v-else-if="!childIndex">
									<router-view></router-view>
								</div>
							</transition>
						</el-col>
					</div>
				</section>
			</el-col>
		</div>
	</el-row>
</template>

<script>
import autoRouter from '../routes';
import { convertTree, convertAuthor } from '../common/js/util';
import { debuglog } from 'util';
import cookie from 'vue-cookie';
import { setTimeout } from 'timers';

export default {
	data() {
		return {
			paltXt: [],
			editableTabsValue: 0,
			editableTabs: [],
			separe: '', //前后端分离不分离
			cookie: '',
			ifromUrl: '', //ifom跳转页面
			plat: '',
			newRoute: {},
			listIndex: 'author',
			home: true,
			homeList: [],
			platList: [],
			httpUrl: '',
			collapsed: false,
			sysUserName: '',
			sysUserAvatar: '',
			form: {
				name: '',
				region: '',
				date1: '',
				date2: '',
				delivery: false,
				type: [],
				resource: '',
				desc: ''
			},
			mapRoute: [],
			mapRoute2: [],
			mapRoute3: [],
			img: '../../static/images/',
			plind: '',
			admiUrl: '',
			fromRouterData: [],
			clickStus: '',
			token: '',
			buttonCodes: '',
			clickStus2: true,
			platName: '',
			goBack: false,
			goBack2: false,
			yunyinLogo: false,
			setButton: false,
			childIndex: false,
			menuList: [],
			childernXts: []
		};
	},
	methods: {
		childernXt(adminUrl, platID, platName) {
			var _this = this;
			if (platID == 49) {
				window.location.href = adminUrl + '?token=' + this.token + '&source=' + 'operate';
				return false;
			}
			// if(platID == 60){ //测试不要，正式要
			// 	window.location.href= adminUrl	+'?token='+this.token + '&source=' + 'operate'
			// 	return false;
			// }
			_this.childIndex = false;
			_this.$cookie.set('menuIndex', platID, {
				expires: 1
			});
			_this.cookie = cookie.get('menuIndex');
			sessionStorage.setItem('platID', platID);
			sessionStorage.setItem('platName', platName);
			sessionStorage.setItem('adminUrl', adminUrl);
			var getPlatAuthByPlatIdData = {
				platId: platID
			};
			_this.$author.getPlatAuthByPlatId(getPlatAuthByPlatIdData).then(res => {
				if (res.result == '00000000') {
					sessionStorage.setItem('separe', res.data.separe);
					_this.separe = sessionStorage.getItem('separe');
					sessionStorage.setItem('buttonCodes', res.data.buttonCodes);
					sessionStorage.setItem('platlist', JSON.stringify(res.data.menuList));
					this.updataPlatList();
					this.editableTabs = [];
					this.$router.push('/index');
				} else {
					_this.$message({
						message: res.msg,
						type: 'error'
					});
				}
			});
		},
		goOrder() {
			this.$router.go(-1);
		},
		tabQh(item) { },
		handleOpen() { },
		handleClose() { },
		tourles(name) {
			//跳转页面
			this.$router.push({
				path: name
			});
		},
		tourles2(url, name, click) {
			//点击增加数据
			this.ifromUrl = url;
			this.clickStus2 = false;
			setTimeout(() => {
				this.clickStus2 = true;
			}, 10);
			let newTabName = click;

			if (this.editableTabs.length == 0) {
				this.editableTabs.splice(0, 0, {
					title: name,
					name: newTabName,
					ifromUrl: url
				});
			} else {
				const filter = this.editableTabs.filter(item => item.ifromUrl == url);
				if (filter.length === 0) {
					this.editableTabs.splice(this.editableTabs.length, 0, {
						title: name,
						name: newTabName,
						ifromUrl: url
					}); //tab标签
				}
			}
			this.editableTabsValue = newTabName;
		},

		goSet(index, plind) {
			//设置的控制
			if (this.childIndex == true) {
				this.childIndex = false;
				sessionStorage.setItem('id', null);
			} else {
				this.childIndex = false;
				sessionStorage.setItem('id', plind);
			}
			this.$cookie.set('setIndex', index, {
				expires: 1
			}); //权限的
			this.$store.commit('SET_SETTINGROUTES', []); //清空上个路由
			let routes = sessionStorage.getItem('setMenuList'); //取
			routes = JSON.parse(routes);
			this.mapRoute2 = [];
			convertTree(
				routes[0].childMenu,
				{
					children: 'childMenu'
				},
				this.mapRoute2
			); //1获取到的每一个模块的路由,2,判断有没有子节点重新递归
			let ruter = convertAuthor(autoRouter, this.mapRoute2); //第一个参数是自己的路由  2接口获取的初始化路由，路由筛选 最终得出一个路由表
			if (ruter && ruter.length > 0) {
				this.$nextTick(() => {
					this.$store.commit('SET_SETTINGROUTES', ruter);
					this.$router.addRoutes(ruter);
					this.$router.push({
						path: '/setings/AuserManagement'
					}); //跳转权限设置首页
				});
				ruter.unshift({
					path: '/',
					redirect: ruter[0].path
				});
			} else {
				this.$message({
					message: '无可用路由',
					type: 'warning'
				});
			}
			this.updataPlatList();
		},
		goHome(name) {
			this.$router.push(name);
			window.sessionStorage.removeItem('platName');
			if (sessionStorage.getItem('id')) {
				window.sessionStorage.removeItem('id');
			}
		},

		goHome2(name, index) {
			this.childIndex = true;
			// this.platName = '运营平台'
			this.platName = sessionStorage.setItem('platName', '运营平台');
			// window.sessionStorage.removeItem('platName')
			if (sessionStorage.getItem('id')) {
				window.sessionStorage.removeItem('id');
			}
			sessionStorage.removeItem('platlist'); //删除
			sessionStorage.removeItem('platID'); //删除
			sessionStorage.removeItem('adminUrl'); //删除
			this.$cookie.set('menuIndex', index, {
				expires: 1
			});
			this.$store.commit('SET_ROUTES', []); //清空上个路由
			let routes = sessionStorage.getItem('menuList'); //取
			routes = JSON.parse(routes);
			this.mapRoute = [];
			convertTree(
				routes[index].childMenu,
				{
					children: 'childMenu'
				},
				this.mapRoute
			); //1获取到的每一个模块的路由,2,判断有没有子节点重新递归
			let ruter = convertAuthor(autoRouter, this.mapRoute); //第一个参数是自己的路由  2接口获取的初始化路由，路由筛选 最终得出一个路由表
			if (ruter && ruter.length > 0) {
				this.$nextTick(() => {
					this.$store.commit('SET_ROUTES', ruter);
					this.$router.addRoutes(ruter);
					this.$router.push(ruter[0].redirect); //跳转首页
				});
				ruter.unshift({
					path: '/',
					redirect: ruter[0].path
				});
			} else {
				this.$message({
					message: '无可用路由',
					type: 'warning'
				});
			}
		},
		menuOver(ind) {
			this.listIndex = ind;
		},
		menuOut(ind) {
			this.listIndex = 'author';
		},
		onSubmit() { },
		handleopen() { },
		handleclose() { },
		handleselect: function (a, b) { },
		removeTab(targetName) {
			//删除tab
			let tabs = this.editableTabs;
			let activeName = this.editableTabsValue;
			if (activeName === targetName) {
				tabs.forEach((tab, index) => {
					//
					if (tab.name === targetName) {
						//
						let nextTab = tabs[index + 1] || tabs[index - 1];
						//
						if (nextTab) {
							activeName = nextTab.name;
						}
					}
				});
			}
			this.editableTabsValue = activeName;
			this.editableTabs = tabs.filter(tab => tab.name !== targetName);
		},
		//退出登录
		logout: function () {
			var _this = this;
			this.$confirm('确认退出吗?', '提示', {
				//type: 'warning'
			})
				.then(() => {
					sessionStorage.clear();
					localStorage.clear()
					_this.$router.push('/login');
				})
				.catch(() => { });
		},
		showMenu(i, status) {
			this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
		},
		updataPlatList() {
			//子模块的方法
			this.plind = sessionStorage.getItem('platID'); //取
			this.platName = sessionStorage.getItem('platName'); //取

			this.admiUrl = sessionStorage.getItem('adminUrl');
			if (this.plind) {
				let routes = sessionStorage.getItem('platlist'); //取
				this.fromRouterData = JSON.parse(routes);
				this.$store.commit('SET_ROUTES', this.fromRouterData);
				this.$store.commit('settingRoutes', this.fromRouterData);
				this.mapRoute3 = [];
			}
		}
	},
	computed: {
		//vuex取出来渲染用
		routes() {
			return this.$store.state.routes;
		},
		routset() {
			return this.$store.state.settingRoutes;
		}
	},
	created() {
		this.httpUrl = this.Imgurl;
		if (sessionStorage.authorityInfo) {
			this.data = JSON.parse(sessionStorage.authorityInfo);
			this.childernXts = JSON.parse(sessionStorage.authorityInfo);
			//
			// this.platList = this.data.platlist;
			this.paltXt = this.childernXts.platList;
		}
	},
	mounted() {
		this.cookie = cookie.get('menuIndex');
		this.updataPlatList();
		let token1 = JSON.parse(sessionStorage.user);
		this.buttonCodes = sessionStorage.getItem('buttonCodes');
		this.token = token1.token;
		this.separe = sessionStorage.getItem('separe');
		var user = sessionStorage.getItem('user');
		var platID = sessionStorage.getItem('platID');
		this.menuList = JSON.stringify(this.data.menuList);
		if (user) {
			user = JSON.parse(user);
			this.sysUserName = user.userName || '';
			this.sysUserAvatar = user.avatar || '';
		}
		if (platID) {
			this.yunyinLogo = true;
		} else {
			this.yunyinLogo = false;
		}
		this.$nextTick(() => {
			//子模块对接的
			var _this = this;
			let mapFrame = this.$refs['mapFrame'];
			if (mapFrame) {
				if (mapFrame.attachEvent) {
					//兼容浏览器判断
					mapFrame.attachEvent('onload', function () {
						let iframeWin = mapFrame.contentWindow;
						let data = {
							userName: user,
							token: user.token,
							source: 'operate',
							buttonCodes: _this.buttonCodes,
							platID: _this.plind,
							platName: _this.platName
						};
						iframeWin.postMessage(data, _this.admiUrl);
					});
				} else {
					mapFrame.onload = function () {
						let iframeWin = mapFrame.contentWindow;
						let data = {
							userName: user,
							token: user.token,
							source: 'operate',
							buttonCodes: _this.buttonCodes,
							platID: _this.plind,
							platName: _this.platName
						};
						iframeWin.postMessage(data, _this.admiUrl);
					};
				}
			}
		});
		let back2 = sessionStorage.getItem('goback');
		this.goBack2 = back2;
		if (sessionStorage.setMenuList) {
			this.setButton = true;
		} else {
			this.setButton = false;
		}
	},
	watch: {
		$route(to, from) {
			//二级页面
			if (
				to.path == '/memberManagement' ||
				to.path == '/lookProvide' ||
				to.path == '/serviceProviderDetils' ||
				to.path == '/OrderDs_daili' ||
				to.path == '/addActive' ||
				to.path == '/quarterList' ||
				to.path == '/monthlyList' ||
				to.path == '/userDetails' ||
				to.path == '/CommissionDetils' ||
				to.path == '/OrderList' ||
				to.path == '/CustomerDeils' ||
				to.path == '/CommissionList' ||
				to.path == '/Customer' ||
				to.path == '/agentDetils' ||
				to.path == '/orderDetils' ||
				to.path == '/versionManagement' ||
				to.path == '/newsDetils' ||
				to.path == '/ruleCoupon' ||
				to.path == '/addCoupon' ||
				to.path == '/industryPartnersUserDetails' ||
				to.path == '/industryPartnersOrderDetails' ||
				to.path == '/industryPartnersBusinessOpportunityAdd' ||
				to.path == '/industryPartnersBusinessOpportunityDetails' || 
				to.path == '/inviteCodeDetail' || 
				to.path == '/inviteCodeDetail1'
			) {
				this.goBack = true;
				sessionStorage.setItem('goback', this.goBack);
				let back2 = sessionStorage.getItem('goback');
				this.goBack2 = back2;
			} else {
				this.goBack = false;
				sessionStorage.setItem('goback', this.goBack);
				let back2 = sessionStorage.getItem('goback');
				this.goBack2 = back2;
			}
		}
	}
};
</script>

<style>
.el-menu-item-group__title {
	padding: 0px !important;
}

.el-tabs__nav-wrap {
	width: 85% !important;
}

.el-tabs__nav-wrap.is-scrollable {
	width: 1280px !important;
}

.el-tabs--card > .el-tabs__header .el-tabs__nav {
	background: #ffffff !important;
}

.el-tabs__content {
	overflow: none !important;
	position: static !important;
}

.el-submenu .el-menu-item {
	min-width: 189px !important;
	padding-left: 44px !important;
}

.el-menu-vertical-demo {
	background: #46b4ff !important;
}

.el-menu--collapse {
	width: 60px !important;
}

.el-submenu__title i {
	color: #ffffff !important;
}

.el-menu-item.is-active {
	background: rgba(255, 255, 255, 0.4) !important;
	color: #ffffff !important;
}

.el-menu--collapse > .el-submenu > .el-submenu__title span {
	height: 0;
	width: 0;
	overflow: hidden !important;
	visibility: inherit !important;
	display: initial !important;
	margin-left: 5px;
	margin-right: 5px;
}
</style>

<style scoped lang="scss">
.userinfo-inner2 {
	margin-left: 20px;
}

.title_updata {
	float: left;
	font-size: 14px;
	margin-left: 35px;
	color: #666666;
}

.title_name {
	float: left;
	font-size: 14px;
	margin-left: 35px;
	color: #666666;
}

.yuyings {
	float: right;
	font-size: 14px;
	color: #666666;
	cursor: pointer;
}

.goOrder {
	float: left;
}

.goOrder button {
	margin-left: 20px;
}

.collImg {
	font-size: 20px;
	color: #ffffff;
	line-height: 50px;
}

@import '~scss_vars';

.icons {
	width: 20px;
	height: 20px;
	display: inline-block;
	line-height: 0px;
}

#ifrm1 {
	position: absolute;
	top: 15px;
	left: 12%;
	height: 92%;
	width: 85%;
	background: #ffffff;
	border-top: 1px solid #e4e7ed;
}

#ifrm1s {
	position: absolute;
	top: 15px;
	left: 6%;
	height: 92%;
	width: 92%;
	background: #ffffff;
	border-top: 1px solid #e4e7ed;
}

#ifrm2 {
	position: absolute;
	top: 41px;
	left: 0%;
	height: 92%;
	width: 86%;
	background: #ffffff;
}

#ifrm2s {
	position: absolute;
	top: 41px;
	left: 0%;
	height: 92%;
	width: 92%;
	background: #ffffff;
	border-top: 1px solid #e4e7ed;
}

@media screen and (max-width: 1600px) {
	#ifrm1 {
		position: absolute;
		top: 15px;
		left: 13%;
		height: 92%;
		width: 85%;
		background: #ffffff;
		border-top: 1px solid #e4e7ed;
	}

	#ifrm1s {
		position: absolute;
		top: 15px;
		left: 6%;
		height: 92%;
		width: 92%;
		background: #ffffff;
		border-top: 1px solid #e4e7ed;
	}

	#ifrm2 {
		position: absolute;
		top: 41px;
		left: 0%;
		height: 92%;
		width: 85%;
		background: #ffffff;
		border-top: 1px solid #e4e7ed;
	}

	#ifrm2s {
		position: absolute;
		top: 41px;
		left: 0%;
		height: 92%;
		width: 92%;
		background: #ffffff;
		border-top: 1px solid #e4e7ed;
	}
}

@media screen and (max-width: 1366px) {
	#ifrm1 {
		position: absolute;
		top: 15px;
		left: 16%;
		height: 90%;
		width: 82%;
		background: #ffffff;
		border-top: 1px solid #e4e7ed;
	}

	#ifrm2 {
		position: absolute;
		top: 41px;
		left: 0%;
		height: 90%;
		width: 82%;
		background: #ffffff;
		border-top: 1px solid #e4e7ed;
	}

	.menu-expanded {
		height: 84vh !important;
	}

	.shipeis {
		width: 120px;
	}
}

#content-container {
	background: rgba(247, 247, 247, 1);
}

.zhedeisi {
	width: 20px;
	height: 65px;
	background: rgba(44, 134, 208, 1);
	border-radius: 0px 5px 5px 0px;
	position: fixed;
	left: 189px;
	top: 355px;
	z-index: 999;
	cursor: pointer;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	-webkit-transition: all 0.3s;
	transition: all 0.3s;

	img {
		width: 12px;
		height: 12px;
	}

	span {
		color: #ffffff;
		font-size: 12px;
		text-align: center;
		margin-top: 5px;
	}
}

.zhedeisi2 {
	width: 20px;
	height: 65px;
	background: rgba(44, 134, 208, 1);
	border-radius: 0px 5px 5px 0px;
	position: fixed;
	left: 60px;
	top: 355px;
	z-index: 99999;
	cursor: pointer;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	-webkit-transition: all 0.3s;
	transition: all 0.3s;

	img {
		width: 12px;
		height: 12px;
	}

	span {
		color: #ffffff;
		font-size: 12px;
		text-align: center;
		margin-top: 5px;
	}
}

.logoFlex {
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.fanhuis {
	float: left;
	width: 80px;
	height: 40px;
	border: 1px solid #303133;
	text-align: center;
	line-height: 40px;
	color: #303133;
	margin-top: 10px;
	margin-left: 10px;
	border-radius: 6px;
	cursor: pointer;
}

.logo {
	width: 198px;
}

.cont {
	width: 944px;
	overflow: hidden;
	margin: 0 auto;
	position: absolute;
	left: calc(50% - 472px);
	top: calc(50% - 202px);
}

.list {
	width: 300px;
	height: 232px;
	border-radius: 6px;
	background: #fff;
	float: left;
	margin: 0 22px 22px 0;
	cursor: pointer;
	transition: all 0.3s linear;
}

.list:hover {
	box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
	transform: translate3d(0, -3px, 0);
}

.Icon {
	width: 125px;
	height: 125px;
	display: block;
	margin: 31px auto 0;
}

.list:nth-of-type(3n) {
	margin-right: 0;
}

.tit {
	font-family: PingFangSC-Regular;
	font-size: 20px;
	color: #373d41;
	letter-spacing: 0;
	text-align: center;
	padding: 17px 0 0 0;
}

.container {
	background: #f5f5f6;
	position: absolute;
	top: 0px;
	bottom: 0px;
	width: 100%;

	.header {
		display: flex;
		height: 60px;
		line-height: 60px;
		background: $color-primary;
		box-shadow: 0 0 25px #cac6c6;
		color: #303133;

		.flex_righs {
			flex: 1;
			border-bottom: 1px solid #cdcdcd;
		}

		.userinfo {
			text-align: right;
			padding-right: 35px;
			float: right;

			.userinfo-inner {
				cursor: pointer;

				img {
					width: 40px;
					height: 40px;
					border-radius: 20px;
					margin: 10px 0px 10px 10px;
					float: right;
				}
			}
		}

		.logo {
			width: 230px;
			height: 60px;
			font-size: 22px;

			img {
				cursor: pointer;
				width: 100px;
				margin-top: 20px;
			}

			.txt {
				color: #fff;
			}
		}

		.logo-width {
			width: 189px;
			height: 112px;
			position: relative;
			background: #46b4ff;
			-webkit-transition: all 0.3s;
			transition: all 0.3s;
		}

		.logo-collapse-width {
			position: relative;
			background: #46b4ff;
			width: 60px;
			height: 85px;
			-webkit-transition: all 0.3s;
			transition: all 0.3s;
		}

		.tools {
			padding: 0px 23px;
			width: 14px;
			height: 60px;
			line-height: 60px;
			cursor: pointer;
		}
	}

	.main {
		display: flex;
		position: absolute;
		top: 60px;
		bottom: 0px;
		overflow: hidden;

		aside {
			flex: 0 0 230px;
			width: 230px;

			.el-menu {
				height: 100%;
				overflow-y: inherit;
				background: #46b4ff;
				border: none;
			}

			.el-menu::-webkit-scrollbar {
				display: none;
			}

			.collapsed {
				width: 60px;

				.item {
					position: relative;
				}

				.submenu {
					position: absolute;
					top: 0px;
					left: 60px;
					z-index: 99999;
					height: auto;
					display: none;
					border: 1px solid #c9c9c9;

					li {
						border-bottom: 1px solid #c9c9c9;
					}
				}
			}
		}

		.menu-collapsed {
			flex: 0 0 60px !important;
			width: 60px !important;
			position: relative;
			top: 5px;
			-webkit-transition: all 0.3s;
			transition: all 0.3s;
			overflow: hidden;
		}

		.menu-collapsed {
			flex: 0 0 60px !important;
			width: 60px !important;
			-webkit-transition: all 0.3s;
			transition: all 0.3s;
		}

		.menu-expanded {
			flex: 0 0 189px;
			width: 189px;
			height: 86vh;
			position: relative;
			top: 50px;
			background: #46b4ff;
			-webkit-transition: all 0.3s;
			transition: all 0.3s;
			overflow-y: auto;
		}

		.content-container {
			flex: 1;
			overflow-y: scroll;
			padding: 20px;

			.breadcrumb-container {
				.title {
					width: 200px;
					float: left;
					color: #475669;
				}

				.breadcrumb-inner {
					float: right;
				}
			}

			.content-wrapper {
				// background-color: #fff;
				box-sizing: border-box;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// Home.vue?38c5c02e